<template lang="pug">
    div
        Poptip(:width="explainPoptipWithTable ? 600 : 300"  transfer v-model="visible" style="display:inline")
            Button(shape="circle" icon="md-help" size="small")
            div(slot="title") {{explainPoptipProps.title}}
                span
                    Icon(type="ios-close" size="20" style="float: right" @click="closeExplainPoptipProps")
            div(slot="content" v-if="explainPoptipWithTable")
                Table(border :columns="columns" :data="explainPoptipProps.tableData" max-height="300")
            div(slot="content" v-else)
                div(v-for="(item,idx) in explainPoptipProps.content")
                    p {{idx+1}}. {{item}}
</template>
<script>
export default {
    name: "ExplainPoptip",
    props: {
        explainPoptipProps: { type: Object, default: {} },
        explainPoptipWithTable: { type: Boolean, default: true },
    },
    components: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            columns: [
                {
                    title: this.$t("global.object"),
                    key: "object",
                },
                {
                    title: this.$t("global.explanation"),
                    key: "explain",
                },
            ],
            visible: false,
        };
    },
    methods: {
        closeExplainPoptipProps() {
            this.visible = false;
        },
    },
    mounted() {},
    computed: {},
};
</script>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/PoptipInfos/ExplainPoptip.vue